/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getSwagger200Schema = z.any();

export const getSwaggerQueryResponseSchema = z.lazy(() => getSwagger200Schema);
